import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';
import { SportType } from '../../types/sport.type';

/**
 * Mode d'entrainement d'un coaching selon son sport : en coaching il n'y a qu'un seul mode par sport.
 */
export const COACHING_WORKOUT_MODE_BY_SPORT: Readonly<Record<SportType, WorkoutMode>> = {
  cycling: 'res',
  running: 'res',
  rowing: 'res',
};
